import React from 'react';
import './generalFormTitleShow.css';
import { ChevronRight } from 'lucide-react';
import { PROFILE } from '../../../constant/Routes.js';

const GeneralFormTitleShow = ({ title, hasOuterURL = false, outerUrl, innerComponent }) => {
  return (
    <div className='form-title-content'>
      {/* Left side - Inner Component */}
      <div className='left-section'>{innerComponent}</div>

      {/* Center - Title */}
      <h5 className={'form-title'} style={{ fontSize: !!innerComponent ? '14px' : '17px', flex: !!innerComponent ? 2 : 3 }}>
        {title}
      </h5>

      {/* Right side - Back button */}
      <div className='right-section'>
        <a href={hasOuterURL ? outerUrl : PROFILE} style={{ display: 'flex', flexDirection: 'row-reverse', alignItems: 'center' }}>
          <ChevronRight size={24} />

          <h5 className={'form-back'}>برگشت</h5>
        </a>
      </div>
    </div>
  );
};

export default GeneralFormTitleShow;
